import React from "react";
import { Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import { useState, useEffect } from "react";
import groupBy from 'lodash/groupBy';
import SmHeader from "../../components/ForPages/SmHeader";
import HomeHeader from "../../components/ForPages/HomeHeader";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { getForm } from "../../actions/forms";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom'
import Design from "../../components/ForPages/Design";
import Footer from "../../components/ForPages/Footer";
import PaymentPopup from "../../components/PaymentPopup";
import "../../pages/Home/Home.css";
import "../../pages/Home/Responsive.css";
import { useHistory } from "react-router-dom";
import ClientCreateDesignForm from "../../components/userForms/ClientCreateDesignForm";
import axiosInstance from "../../utils/config";
import { canvas_designs } from "../../utils/designsTypes";
import Loader from "../../components/Loader";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./style.css";
SwiperCore.use([EffectCoverflow, Pagination]);

const ViewAll = (props) => {
    document.body.style.backgroundColor = "#E5E4EF";
    const [showCreateDesignForm, setShowCreateDesignForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch(),
        [monthDownloadNbr, setMonthDownloadNumber] = useState(257),
        [totalDownloadNumber, setTotalDownloadNumber] = useState(500),
        [PaymentPopupDisplay, setPaymentPopupDisplay] = useState("none");
    const userToken = localStorage?.getItem("skiUserToken");
    const [canvasStrings, setCanvasStrings] = useState([]);
    const [designs, setDesigns] = useState({}),
        [userRole, setUserRole] = useState("client"),
        history = useHistory();
    const [sub, setSub] = useState([])
    const location = useLocation()
    const { data, name } = location.state


    console.log(location)

    // useEffect(() => {
    //     document.title = "Welcome to Ski Studio";
    //     if (userToken) {
    //         try {
    //             let decodedToken = jwt_decode(userToken);
    //             setUserRole(decodedToken.AccountType);
    //             if (decodedToken.AccountType !== "client") history.push("/");
    //         } catch (err) {
    //             history.push("/");
    //         }
    //     } else {
    //         localStorage.removeItem("skiUserToken");
    //         setUserRole("");
    //         history.push("/");
    //     }
    // }, [userToken, history]);

    // useEffect(() => {
    //     let { data, downloadNum } = history.location.state;
    //     console.log(history.location.state)
    //     setTotalDownloadNumber(downloadNum);
    //     setLoading(true);
    //     axiosInstance
    //         .get("/templates", {
    //             headers: {
    //                 Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
    //             },
    //         })
    //         .then((res) => {
    //             if (data.design === 0) return;

    //             let temp_designs = [];
    //             console.log(res)


    //             let temp_data = res.data.data.filter(
    //                 (x) => x.Category === data.design && x.isPublished
    //             );
    //             temp_data = temp_data.slice(0, 30);
    //             console.log(temp_data)
    //             let canva_design = canvas_designs.find((d) => d.value === data.design);

    //             temp_data = temp_data.map((t) => {
    //                 let new_t = {
    //                     imgSrc: "/Images/groovinx.png",
    //                     title: t.Name,
    //                     type: t.Category,
    //                     width: canva_design.width,
    //                     height: canva_design.height,
    //                     data,
    //                     templateFile: t.templateFile,
    //                     _id: t._id,
    //                     sub: t.sub
    //                 };

    //                 temp_designs.push(t.templateFile);

    //                 return new_t;
    //             });

    //             const categories = temp_data.reduce((group, product) => {
    //                 const { sub } = product;
    //                 group[sub] = group[sub] ?? [];
    //                 group[sub].push(product);
    //                 return group;
    //             }, {});
    //             console.log(categories)

    //             setCanvasStrings(temp_designs);
    //             setDesigns(categories);
    //             setLoading(false);
    //             setSub(Object.keys(designs))
    //             console.log(Object.keys(designs))

    //             console.log(res)
    //         })
    //         .catch((err) => (setLoading(false), console.log(err)));

    //     // loadFonts();
    // }, []);
    // console.log(`this is${designs.length}`);
    // Object.values(designs).map((design, key) => console.log(design))
    // console.log(sub)




    return (
        <>
            {showCreateDesignForm && <ClientCreateDesignForm />}
            <div className="Home ViewAll">
                {userRole !== "client" && <Redirect to="/" />}
                {/* <SmHeader />
                <HomeHeader
                    tab="home"
                    include=""
                    showPaymentPopup={setPaymentPopupDisplay}
                /> */}
                <div className="creative-designs-list mt-0">
                    <div className="design">
                <button
                            className="biz-btn btn text-white btn-sm px-3 shadow-sm"
                            style={{ background: "black", marginLeft: "5em" ,marginTop:"5em"}}
                            onClick={() => history.push("/client-home")}
                        >
                            Back
                        </button>
                        </div>
                        <div className="flex align-center text-center justify-center p-3">
                            <button className="btn1">
                                ALL

                            </button>
                            <button className="btn2">
                                Images

                            </button>
                            <button className="btn3">
                                Videos

                            </button>

                        </div>

                    <div className="d-flex align-items-center ">


                     
                        <h3
                            className="text-center p-3"
                            style={{ width: "84vw", fontFamily: "Ubuntu" }}
                        >
                            {name}
                        </h3>
                    </div>
                    <div>


                        {loading ? (
                            <Loader />
                        ) :





                            <Swiper
                                slidesPerView={1}
                                spaceBetween={100}
                                freeMode={true}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Pagination]}
                                className="mySwiper"
                                breakpoints={{
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 30,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 40,
                                    },
                                    1024: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                }}
                            >
                                {(
                                    designs && data.map((design, index1) => (<SwiperSlide>

                                        <Design
                                            key={index1}
                                            design={design}
                                            downloadNum={totalDownloadNumber}
                                        /></SwiperSlide>))

                                )
                                }


                            </Swiper>

                        }

                    </div>
                </div>

                <PaymentPopup
                    display={PaymentPopupDisplay}
                    hidePopupDisplay={setPaymentPopupDisplay}
                />
            </div>
        </>
    );
};

export default ViewAll;


